var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog__content"},[(_vm.headline)?_c('Headline',{staticClass:"modal-dialog__headline",attrs:{"value":_vm.headline}}):_vm._e(),_vm._v(" "),(_vm.response && _vm.response.type === 'string')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.response.content)}}):_c('div',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0bdaed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Content.vue
// module id = 1071
// module chunks = 1